import { Download, HelpCircle, Trash, X } from "lucide-react";
import { useQuery, useMutation } from "react-query";
import {
  deleteLoanApplicationDocument,
  getLoanApplicationDocuments,
} from "../../../sdk/applications/applications";
import { useFormattedDate } from "../../../hooks/useFormattedDate";
import { useError } from "../../../context/ErrorProvider";

const AllDocuments = ({
  closeAllDocuments,
  loanApplication,
  handleOpenAddDocument,
  refetchApplication,
}) => {
  const formattedDate = useFormattedDate();
  const { showError } = useError();
  const { data: documents, refetch } = useQuery({
    queryKey: ["loan documents", loanApplication?.id],
    queryFn: () => getLoanApplicationDocuments(loanApplication?.id),
    initialData: [],
    enabled: !!loanApplication?.id,
  });

  const { mutate: deleteDocument } = useMutation({
    mutationKey: ["delete document"],
    mutationFn: (id) => deleteLoanApplicationDocument(loanApplication?.id, id),
    onSuccess: () => {
      refetchApplication();
      refetch();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const handleDeleteDocument = (document) => {
    deleteDocument(document?.id);
  };
  return (
    <div
      onClick={() => closeAllDocuments()}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[600px] rounded-[10px] p-[20px] relative bg-white overflow-y-auto"
      >
        <div
          onClick={closeAllDocuments}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="text-[#000000] font-normal text-[14px]">
          Edit Loan Application
        </p>
        <p className="text-[#000000] font-semibold text-[20px]">
          Borrower’s loan documents information
        </p>
        <div className="flex items-center mb-[10px] justify-between">
          <p className="text-[#5C5C5C] text-[14px] font-normal">
            Upload relevant documents associated with the loan application
          </p>
          <button
            onClick={handleOpenAddDocument}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            Add Document
          </button>
        </div>
        <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
          <div className="w-[10%]">ID</div>
          <div className="w-[20%] text-[14px] text-[#222222] font-normal">
            NAME
          </div>
          <div className="w-[20%] text-[14px] text-[#222222] font-normal">
            UPDATED
          </div>
          <div className="w-[20%] text-[14px] text-[#222222] font-normal">
            STATUS
          </div>
          <div className="w-[30%] truncate text-[14px] text-[#222222] font-normal">
            DOWNLOAD/ DELETE
          </div>
        </div>
        {documents.length > 0 ? (
          documents.map((doc) => (
            <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
              <div className="w-[10%] truncate">{doc?.id}</div>
              <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                {doc?.documentName}
              </div>
              <div className="w-[20%] text-[14px] truncate text-[#222222] font-normal">
                {formattedDate(doc?.uploadedAt)}
              </div>
              <div className="w-[20%] capitalize text-[14px] text-[#222222] font-normal">
                Uploaded
              </div>
              <div className="w-[30%] flex gap-3 items-center truncate text-[14px] text-[#222222] font-normal">
                {/* <Eye className="w-4 h-4 text-[#222222] cursor-pointer" /> */}
                <Download className="w-4 h-4 text-[#222222] cursor-pointer" />
                <Trash
                  onClick={() => handleDeleteDocument(doc)}
                  fill="#222222"
                  className="w-4 h-4 text-[#222222] cursor-pointer"
                />
              </div>
            </div>
          ))
        ) : (
          <div className="h-[350px] flex flex-col items-center justify-center gap-[10px]">
            <HelpCircle />
            <p>No loan document information available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllDocuments;
